import { CustomersMajor, DigitalMediaReceiverMajor } from '@shopify/polaris-icons';
import { ItemProps } from '@shopify/polaris/build/ts/latest/src/components/Navigation/components/Item/Item';

export const edgelinkDeviceRoutes: ItemProps = {
  label: 'Devices',
  url: '#',
  icon: DigitalMediaReceiverMajor,
  subNavigationItems: [
    {
      url: '/edgelink',
      disabled: false,
      label: 'Account Dashboard',
    },
    {
      url: '/edgelink/devices/map',
      disabled: false,
      label: 'Map View',
    },
    {
      url: '/edgelink/devices/cards',
      disabled: false,
      label: 'Card View',
    },
    {
      url: '/edgelink/devices/table',
      disabled: false,
      label: 'Table View',
    },
  ],
};

export const edgelinkAccountManagementRoutes: ItemProps = {
  label: 'Account Management',
  url: '#',
  icon: CustomersMajor,
  matches: true,
  subNavigationItems: [
    {
      url: '/edgelink/company/users',
      disabled: false,
      label: 'Users',
    },
    {
      url: '/edgelink/company/devices',
      disabled: true,
      label: 'Devices',
    },
    {
      url: '/edgelink/company/',
      disabled: false,
      label: 'Company',
    },
    {
      url: '/edgelink/company/alerts',
      disabled: true,
      label: 'Geofencing Alerts',
    },
  ],
};

export const edgelinkProductManagementRoutes: ItemProps = {
  label: 'Product Management',
  url: '#',
  icon: CustomersMajor,
  matches: true,
  subNavigationItems: [
    {
      url: '/edgelink/products',
      disabled: false,
      label: 'Products',
    },
    {
      url: '/edgelink/delivery_tickets/dashboard',
      disabled: true,
      label: 'Ticket Dashboard',
    },
    {
      url: '/edgelink/delivery_tickets',
      disabled: false,
      label: 'Delivery Tickets',
    },
    {
      url: '/edgelink/containers',
      disabled: false,
      label: 'Containers',
    },
    // {
    //   url: '/edgelink/delivery_tickets/create',
    //   disabled: false,
    //   label: 'Create Delivery Ticket',
    // },
  ],
};

export const edgelinkAdminRoutes: ItemProps = {
  label: 'Admin',
  url: '#',
  icon: CustomersMajor,
  matches: true,
  subNavigationItems: [
    {
      url: '/edgelink/admin/devices',
      disabled: false,
      label: 'Devices Management',
    },
    {
      url: '/edgelink/admin/companies',
      disabled: false,
      label: 'Companies Management',
    },
  ],
};
